export interface HistoryRangeOption {
  readonly value: number;
  readonly label: string;
}

export const HISTORY_RANGE_OPTIONS: readonly HistoryRangeOption[] = [
  { value: 30, label: '30dn' },
  { value: 90, label: '90dn' },
  { value: 180, label: '180dn' },
  { value: 0, label: 'All' }
];

export const DEFAULT_HISTORY_RANGE: number = 30;
